import { Chip, Grid, Typography } from '@mui/material'
import { IntegrationModuleList } from 'common/types/kraken-core/IntegrationModule'

export interface IntegrationModuleItemResultProps {
  module: IntegrationModuleList
}

export const IntegrationModuleItemResult = ({ module }: IntegrationModuleItemResultProps) => {
  const tags = module.capability ? [module.capability.name, ...(module.metadata?.tags || [])] : []
  return (
    <Grid container spacing={1} alignItems={'center'}>
      <Grid item>
        <Typography variant="body2">{module.name}</Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={1}>
          {tags.map(tag => {
            return (
              <Grid key={tag} item>
                <Chip label={tag} size="small" />
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </Grid>
  )
}
